import { Button, Card, CardContent, Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { getSitekey } from '../../../core/common/recaptcha';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { AdditionalInfoText } from '../../components/inputs/additional-info-text';
import { StyledReCAPTCHA } from '../../styles';
import { ContractWithdrawalStore } from '../contract-withdrawal-store';
import { ConfirmationEmailInput } from '../inputs/confirmation-email-input';

export const ContractWithdrawalManualForm = observer(() => {
    const { translate } = injectTSDI(I18n);
    const contractWithdrawalStore = injectTSDI(ContractWithdrawalStore);

    if (!contractWithdrawalStore.withdrawContractManualForm) {
        return <></>;
    }

    const { additionalInformation, confirmationEmail } =
        contractWithdrawalStore.withdrawContractManualForm.wrappedField;

    const recaptchaRef = React.createRef<ReCAPTCHA>();

    return (
        <Card variant="outlined">
            <CardContent>
                <Grid container spacing={5}>
                    <Grid item>
                        <Grid
                            container
                            justifyContent="space-between"
                            alignItems="flex-start"
                            spacing={3}
                        >
                            <Grid item xs={12}>
                                <AdditionalInfoText
                                    additionalInformationField={
                                        additionalInformation
                                    }
                                    helperText={translate(
                                        'public.content.withdraw.contract.manual.info'
                                    )}
                                    data-role="manual-contract-withdrawal-additional-info"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <ConfirmationEmailInput
                                    confirmationEmailField={confirmationEmail}
                                    data-role="manual-confirmation-email"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <StyledReCAPTCHA
                                    sitekey={getSitekey()}
                                    ref={recaptchaRef}
                                    size="invisible"
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    type="submit"
                                    data-role="submit-manual-contract-withdrawal"
                                    onClick={() => {
                                        void contractWithdrawalStore.handleWithdrawManual(
                                            recaptchaRef
                                        );
                                    }}
                                >
                                    {translate(
                                        'public.content.withdraw.confirm.contract.withdrawal'
                                    )}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
});
